module.exports = __webpack_public_path__ + "img/tanjaroehm.a4646a99.jpg";